module.exports = __webpack_public_path__ + "img/pic_13.224de98d.jpg";